import { css } from "styled-components";
import { COLORS } from "../../design/tokens";

const styles = {
  container: css`
    width: ${({ fluid }) => (fluid ? "100%" : "675px")};
  `,
  topContainer: css`
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    justify-content: space-between;
  `,
  topButtonContainer: css`
    cursor: pointer;

    &:hover {
      opacity: 0.75;
    }
  `,
  collapseFormContainer: css`
    text-align: center;
    margin-bottom: 16px;
  `,
  collapseFormLabel: css`
    color: ${COLORS.FORM.COLLAPSED.TEXT};
    position: relative;
    cursor: pointer;
    &:after {
      border-bottom: 1.5px dashed ${COLORS.FORM.COLLAPSED.BORDER};
      content: "";
      height: 1px;
      width: 100%;
      position: absolute;
      left: 50%;
      bottom: -1px;
      transform: translateX(-50%);
    }

    &:hover {
      opacity: 0.75;
    }
  `,
  formSection: css`
    height: 100%;
    width: 100%;
    padding: 40px 31px 31px;
  `,
  buttonsContainer: css`
    margin-top: 40px;
  `,
  mandatoryFieldsLabelContainer: css`
    margin-top: 56px;
  `,
  mandatoryFieldsLabel: css`
    font-size: 14px;
    color: #5D737E
  `,
  messageContainer: css`
    margin-bottom: 30px;
    flex-direction: column;
  `,
  bottomComponentContainer: css`
    margin-bottom: 20px;
  `,
  sectionTitleContainer: css`
    margin-bottom: 14px;
    margin-top: 20px;
  `
};

export default styles;
